module.exports = __webpack_public_path__ + "img/color-wheel.5c2b145b.png";